<template>
  <div>
    <v-btn
      v-if="interactionMeta.isInteractionAnswered"
      @click.prevent="editInteraction()"
      aria-label="Edit"
      class="edit-free-response"
      icon
      :ripple="false"
      ><v-icon id="edit-icon">edit</v-icon></v-btn
    >
    <v-btn
      v-if="!interactionMeta.isInteractionAnswered && editFreeResponseState"
      @click.prevent="closeRTE()"
      :disabled="interactionMeta.isProcessingData"
      aria-label="Close Editor"
      class="close-edit"
      icon
      :ripple="false"
    >
      <v-icon id="close-icon">close</v-icon>
    </v-btn>
  </div>
</template>

<script>
/* global _ */

// Components:
import EventBus from '@/buses/EventBus';
import PlayerService from '@/services/PlayerService';

// Plugins / Libraries:
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'free-response-edit',
  props: {
    interactionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      lastResponse: null,
    };
  },
  computed: {
    ...mapGetters('interactions', [
      'interaction',
      'interactionAttempt',
      'interactionMeta'
    ]),
    ...mapState('interactions', ['editFreeResponseState']),
    interaction() {
      return this.$store.getters['interactions/interaction'](this.interactionId) || {};
    },
    interactionAttempt() {
      return this.$store.getters['interactions/interactionAttempt'](this.interactionId) || {};
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interactionId) || {};
    },
  },
  methods: {
    ...mapMutations('interactions', ['setEditFreeResponse']),
    editInteraction() {
      this.setEditFreeResponse();
      this.saveResponseText();
      this.interactionMeta.isInteractionAnswered = false;
      this.interactionMeta.useRichText = true;
      this.interactionMeta.sessionStartTime = moment().valueOf();
    },
    closeRTE() {
      this.setEditFreeResponse();
      this.setResponseText();
      this.interactionMeta.isInteractionAnswered = true;
      this.interactionMeta.useRichText = false;
    },
    saveResponseText() {
      this.lastResponse = this.interactionAttempt.responseText[0];
    },
    setResponseText() {
      this.interactionAttempt.responseText[0] = this.lastResponse;
    },
  },
};
</script>
<style scoped>
.edit-free-response:before {
  opacity: 0 !important;
}
.close-edit:before {
  opacity: 0 !important;
}

#edit-icon {
  font-size: 20px;
  color: #6b7280;
}

#close-icon {
  font-size: 18px;
  font-weight: 900;
  color: #6b7280;
}
</style>
